import { render, staticRenderFns } from "./AdminComplaintsDashboard.vue?vue&type=template&id=f458535a&scoped=true"
import script from "./AdminComplaintsDashboard.vue?vue&type=script&lang=js"
export * from "./AdminComplaintsDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdminComplaintsDashboard.vue?vue&type=style&index=0&id=f458535a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f458535a",
  null
  
)

export default component.exports